import _ from 'lodash'

export function filtro(
    nascimentos,
    searchFazenda,
    searchMatrizNumero,
    searchBezerroNumero,
    searchDataInicial,
    searchDataFinal,
    searchStatus
) {

    return nascimentos?.filter(nascimento => {
        const matchesFazenda = nascimento.fazenda.nome.toUpperCase().includes(searchFazenda.toUpperCase())

        const matchesMatriz = !searchMatrizNumero || nascimento.matriz?.numero?.includes(searchMatrizNumero)

        const matchesBezerro = !searchBezerroNumero || nascimento.numBezerro?.toUpperCase().includes(searchBezerroNumero.toUpperCase())

        const matchesStatus = !searchStatus || nascimento.status?.includes(searchStatus)

        const afterDataInicial = !searchDataInicial || nascimento.data.seconds * 1000 >= new Date(searchDataInicial).getTime()

        // 86400000 = 1 dia
        const beforeDataFinal = !searchDataFinal || nascimento.data.seconds * 1000 <= new Date(searchDataFinal).getTime() + 86400000

        return matchesFazenda && matchesMatriz && matchesBezerro && matchesStatus && afterDataInicial && beforeDataFinal
    })
}

export function exportAtual(nascimentos) {
    let conf = [
        { labelCol: "Fazenda", getValue: "fazenda.nome" },
        { labelCol: "Matriz", getValue: "matriz.numero" },
        { labelCol: "ERA", getValue: "matriz.era" },
        { labelCol: "Lote", getValue: "matriz.lote" },
        { labelCol: "Retiro", getValue: "matriz.retiro" },
        { labelCol: "Raça Matriz", getValue: "matriz.raca" },
        {
            labelCol: "Data", getValue: (value) => {
                try {
                    let dateV = value.data.toDate().toISOString().split("T")[0];
                    dateV = dateV.split("-").reverse().join("/")
                    return dateV;
                } catch { }
            }
        },
        { labelCol: "Bezerro", getValue: (l) => l.numBezerro },
        { labelCol: "Peso", getValue: "peso" },
        { labelCol: "Sexo", getValue: "sexo" },
        { labelCol: "Raça Bezerro", getValue: "raca" },
        { labelCol: "Status", getValue: "statusBezerro" },
        { labelCol: "Observação", getValue: "obsParto" },
    ]
    exportCsv(nascimentos, conf)

}

const exportCsv = (list, conf) => {
    let strCsv = '';
    let separator = ';'
    conf.forEach(c => { strCsv += c.labelCol + separator })
    strCsv += '\n'
    list.forEach(l => {
        conf.forEach(c => {
            let v = ""
            if (_.isString(c.getValue)) {
                v = _.get(l, c.getValue);
                if (v) {
                    v = '"' + v + '"'
                }
            } else {
                v = c.getValue(l);
            }
            if (!v) {
                v = ''
            }
            strCsv += v + separator
        })
        strCsv += '\n'
    })
    gerarArquivo(strCsv, "Exportar Nascimentos.csv")
}

const gerarArquivo = (texto, nome) => {

    let fileBlob = new Blob(["\ufeff", texto]);
    if (window.cordova) {
        document.addEventListener("deviceready", function () {
            var storageLocation = "";
            console.log('window.cordova', window.cordova)
            // switch (window.cordova.device.platform) {
            //     case "Android":
            storageLocation = window.cordova.file.dataDirectory;
            //         break;
            //     case "iOS":
            //         storageLocation = window.cordova.file.documentsDirectory;
            //         break;
            //     default:
            //         storageLocation = window.cordova.file.externalDataDirectory;
            // }

            var folderPath = storageLocation;
            console.log('folderPath', folderPath)
            console.log('nome', nome)
            window.resolveLocalFileSystemURL(
                folderPath,
                function (dir) {
                    console.log("Access to the directory granted succesfully", dir);
                    dir.getFile(
                        nome,
                        {
                            create: true
                        },
                        function (file) {
                            console.log('file', file)
                            file.createWriter(
                                function (fileWriter) {
                                    fileWriter.write(fileBlob);

                                    fileWriter.onwriteend = function () {
                                        var url = file.toURL();
                                        console.log('url', url)
                                        window.cordova.plugins.fileOpener2.open(folderPath + nome, "text/plain", {
                                            error: function error(err) {
                                                console.error(err);
                                                alert("Unable to download3");
                                            },
                                            success: function success() {
                                                console.log("success with opening the file");
                                            }
                                        });
                                    };

                                    fileWriter.onerror = function (err) {
                                        alert("Unable to download2");
                                        console.error(err);
                                    };
                                },
                                function (err) {
                                    // failed
                                    alert("Unable to download");
                                    console.error('err', err);
                                }
                            );
                        },
                        function (err) {
                            alert("Unable to download");
                            console.error(err);
                        }
                    );
                },
                function (err) {
                    alert("Unable to download");
                    console.error(err);
                }
            );
        });
    } else {

        var element = document.createElement("a");

        // let file = new Blob([texto], { type: "text/plain;charset=utf-8" });
        element.href = URL.createObjectURL(fileBlob);
        element.download = nome;
        element.click();
    }
}